module.exports = __webpack_public_path__ + "img/13.5b0bbf49.jpg";